import * as Sfx from "redux-saga/effects";
import {setBetCost} from "@atg-sport-shared/sportsbook-data-access-kambi";
import {SET_BETSLIP_OUTCOMES} from "./betslip.actions";

export function* resetBetCost(): Generator<Sfx.Effect, void, any> {
    yield Sfx.put(setBetCost(0));
}

export function* betslipSaga(): Generator<Sfx.Effect, void, any> {
    yield Sfx.takeLatest([SET_BETSLIP_OUTCOMES], resetBetCost);
}
